"use strict";(()=>{const c=e=>String(e??"").replace(/[&<>'"]/g,t=>({"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"})[t]),m=e=>new Intl.NumberFormat("ro-RO",{style:"currency",currency:"RON"}).format(Number(e||0)).replace(/RON$/, "lei"),l=()=>window.Shopify?.routes?.root||"/",p=e=>`${l()}products/${encodeURIComponent(e)}`,f=e=>String(e?.legacyResourceId||String(e?.shopifyId||"").split("/").pop()||e?.id||""),g=e=>`${l()}apps/recommendations-intelligence?${new URLSearchParams(e).toString()}`,y=e=>document.cookie.split(";").map(t=>t.trim()).find(t=>t.startsWith(`${e}=`))?.split("=").slice(1).join("=")||"",b=()=>{try{const e=window.Shopify?.customerPrivacy;return typeof e?.preferencesProcessingAllowed=="function"?!!e.preferencesProcessingAllowed():!0}catch{return!0}},$=()=>{if(!b())return"";let e=decodeURIComponent(y("ri_client_id")||"");return e||(e=globalThis.crypto?.randomUUID?.()||`ri-${Date.now()}-${Math.random().toString(36).slice(2)}`,document.cookie=`ri_client_id=${encodeURIComponent(e)}; path=/; max-age=31536000; SameSite=Lax`),e},u=(e,t=24)=>`<svg viewBox="0 0 ${t} ${t}" aria-hidden="true">${e}</svg>`,w=u('<path d="M6.8 8.5h10.4l1 11H5.8l1-11Z"/><path d="M9 9V6.8a3 3 0 0 1 6 0V9"/>'),S=u('<path d="m5 12.5 4.2 4.2L19 7.5"/>'),L=u('<path d="M20.5 5.5 10 16l10.5 10.5"/>',32),C=u('<path d="M11.5 5.5 22 16 11.5 26.5"/>',32);/* 4.1.8: display-only suffix extraction; never infer a new size or alter stored titles. */
function iuCartLabel(title){
 const original=String(title||'').trim();
 const name=original.replace(/\s*[–—-]\s*(?:Femei|Bărbați|Barbati|Unisex)\s*$/i,'').trim();
 const suffix=name.match(/(?:\s*[–—-]\s*(?:m[aă]rimea\s+)?|\s+m[aă]rimea\s+)((?:XXS|XS|S|M|L|XL|XXL|[2-6]XL|W\d{2}|\d{2,3})(?:(?:\s*\/\s*|\s+)(?:XXS|XS|S|M|L|XL|XXL|[2-6]XL|W\d{2}|L\d{2}|\d{2,3}))*)(?:\s+(\([^()]*\)))?$/i);
 if(!suffix)return {title:name||original,size:''};
 const clean=name.slice(0,suffix.index).replace(/\s*[–—-]\s*$/,'').trim();
 return clean?{title:clean+(suffix[2]?' '+suffix[2]:''),size:suffix[1].replace(/\s*\/\s*/g,'/').toUpperCase()}:{title:original,size:''};
}
const iuCartImageSizes='(min-width:1200px) calc((100vw - clamp(24px,2.4vw,40px) * 2 - 88px)/5),(min-width:1025px) calc((100vw - clamp(24px,2.4vw,40px) * 2 - 66px)/4),(min-width:750px) calc((100vw - 68px)/3),calc((100vw - 46px)/2)';
function I(e){const label=iuCartLabel(e.title),t=p(e.handle),a=f(e),i=Number(e.variantCount)===1&&e.variantId,r=Number(e.variantCount)>1,s=i?` data-variant-id="${c(e.variantId)}"`:r?' data-choose-options="1"':" disabled",d=r?"Alege opțiunile":i?"Adaugă în coș":"Epuizat",o=Number(e.price||0),n=Number(e.compareAtPrice||0),k=n>o?`<span class="ri-cu-compare">${m(n)}</span><span class="ri-cu-sale">${m(o)}</span>`:m(o),v=String(e.vendor||"").trim(),b=v.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase(),brand=["premium","smart","luxury","vintage","sport","alte branduri","alte marci"].includes(b)?"":v;return`<article class="ri-cu-card ri-card${e.secondaryImage?' iu-cart-has-second':''}" data-ri-cu-card data-ri-card data-product-id="${c(a)}" data-handle="${c(e.handle)}">
 <div class="ri-cu-image ri-image-wrap"><a class="ri-image-link" href="${c(t)}" aria-label="${c(e.title)}">${e.image?`<img class="ri-img-primary" data-ri-src="${c(e.image)}" data-ri-sizes="${c(iuCartImageSizes)}" alt="${c(e.title)}" width="600" height="900" decoding="async">`:""}${e.secondaryImage?`<img class="ri-img-secondary" data-ri-src="${c(e.secondaryImage)}" data-ri-sizes="${c(iuCartImageSizes)}" alt="${c(e.title)} — vedere secundară" width="600" height="900" decoding="async">`:""}</a>
 <a class="ri-card-action ri-wish" href="${c(t)}" data-wishlist data-wishlist-handle="${c(e.handle)}" data-product-id="${c(a)}" aria-label="Adaugă la favorite" title="Adaugă la favorite">${u('<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/>')}</a>
 <button class="ri-cu-add ri-card-action ri-cart" type="button" data-ri-cu-add${s} aria-label="${d}" title="${d}">${w}<span class="ri-cu-label">${d}</span></button></div>
 <div class="iu-related-meta"><span class="iu-related-brand" title="${c(brand)}">${c(brand)}</span></div>
 <div class="ri-cu-body ri-card-body"><a class="ri-cu-title-link ri-title-link" href="${c(t)}"><h3 class="ri-cu-card-title ri-card-title">${c(label.title)}</h3></a>${label.size?`<p class="iu-cart-card-size">Mărime <strong>${c(label.size)}</strong></p>`:''}<div class="ri-cu-price ri-card-price">${k}</div></div>
 </article>`}function E(e,t){const a=`ri-cu-${Math.random().toString(36).slice(2)}`;return`<section class="ri-cu-section"><h2 class="ri-cu-heading">${c(e)}</h2><div class="ri-cu-carousel"><button class="ri-cu-arrow ri-cu-left" type="button" data-ri-cu-left="${a}" aria-label="\xCEnapoi">${L}</button><div class="ri-cu-rail" id="${a}">${t.map(I).join("")}</div><button class="ri-cu-arrow ri-cu-right" type="button" data-ri-cu-right="${a}" aria-label="\xCEnainte">${C}</button></div></section>`}const iuCartCarouselCleanups = new WeakMap();
function A(root) {
 iuCartCarouselCleanups.get(root)?.();
 const cleanups = [];
 root.querySelectorAll('[data-ri-cu-left]').forEach(left => {
  const id = left.dataset.riCuLeft, rail = document.getElementById(id);
  const right = root.querySelector(`[data-ri-cu-right="${CSS.escape(id)}"]`);
  if (!rail || !right) return;
  const sync = () => { const end = Math.max(0,rail.scrollWidth-rail.clientWidth-2);left.disabled=rail.scrollLeft<=2;right.disabled=rail.scrollLeft>=end; };
  const previous = () => rail.scrollBy({left:-(rail.clientWidth*.98),behavior:'smooth'});
  const next = () => rail.scrollBy({left:rail.clientWidth*.98,behavior:'smooth'});
  left.addEventListener('click',previous);right.addEventListener('click',next);
  rail.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync,{passive:true});
  cleanups.push(() => { left.removeEventListener('click',previous);right.removeEventListener('click',next);rail.removeEventListener('scroll',sync);window.removeEventListener('resize',sync); });
  requestAnimationFrame(sync);
 });
 iuCartCarouselCleanups.set(root,() => { cleanups.forEach(dispose=>dispose());iuCartCarouselCleanups.delete(root); });
}
async function M(){const e=await fetch(`${l()}cart.js`,{headers:{Accept:"application/json"},credentials:"same-origin"});if(!e.ok)throw new Error("cart unavailable");return e.json()}async function O(e,t){const a=$();if(!(!a||!e))try{await fetch(g({action:"event"}),{method:"POST",headers:{"Content-Type":"application/json"},credentials:"same-origin",keepalive:!0,body:JSON.stringify({clientId:a,eventId:`${a}:ADD_TO_CART:${e}:${Date.now()}`,eventType:"ADD_TO_CART",productId:String(e),timestamp:new Date().toISOString(),metadata:{source:"cart_upsell",sourceProductIds:t.split(",").filter(Boolean)}})})}catch{}}/* 4.4.25: use confirmed native cart events; discard stale recommendations. */
const iuCartRecommendationStates = new WeakMap();
function iuCartRecommendationState(root) {
 let state = iuCartRecommendationStates.get(root);
 if (!state) {
  state = { generation: 0, cart: null, appliedKey: null, pending: false, timer: null, controller: null };
  iuCartRecommendationStates.set(root, state);
 }
 return state;
}
function iuCartRecommendationIds(cart) {
 return [...new Set((cart.items || []).map(item => String(item.product_id || '')).filter(id => /^\d+$/.test(id)))].sort();
}
function iuCartRecommendationRender(root, html) {
 iuCartCarouselCleanups.get(root)?.();
 iuCartRecommendationState(root).disposePhotos?.();
 iuCartRecommendationState(root).disposePhotos=null;
 const active = root.contains(document.activeElement);
 const feedback = root.querySelector('[data-ri-cu-feedback]');
 root.innerHTML = html;
 if (feedback) root.appendChild(feedback);
 if (active) root.querySelector('[data-ri-cu-add]:not([disabled])')?.focus({ preventScroll: true });
}
function iuCartRecommendationFlush(root) {
 const state = iuCartRecommendationState(root);
 if (!state.pending || root.dataset.riCuAdding === '1') return;
 clearTimeout(state.timer);
 state.timer = setTimeout(() => T(root), 100);
}
function iuCartRecommendationChanged(event) {
 const cart = event.detail;
 if (!cart || !Array.isArray(cart.items)) return;
 document.querySelectorAll('[data-iu-cart-recommendations][data-ri-cu-ready]').forEach(root => {
  const state = iuCartRecommendationState(root);
  if (root.dataset.riCuAdding !== '1' && root.querySelector('[data-ri-cu-feedback]')) iuCartFeedback(root,'');
  state.cart = cart;
  state.generation += 1;
  state.pending = true;
  state.controller?.abort();
  iuCartRecommendationFlush(root);
 });
}
async function T(root) {
 const state = iuCartRecommendationState(root);
 if (root.dataset.riCuAdding === '1') { state.pending = true; return; }
 state.pending = false;
 const generation = state.generation;
 let controller;
 try {
  const cart = state.cart || await M();
  if (generation !== state.generation || !root.isConnected) return;
  state.cart = cart;
  const allIds = iuCartRecommendationIds(cart), key = allIds.join(',');
  if (state.appliedKey === key) return;
  state.controller?.abort();
  controller = new AbortController();
  state.controller = controller;
  root.dataset.riCuLoading = '1';
  root.setAttribute('aria-busy', 'true');
  if (!allIds.length) {
   iuCartRecommendationRender(root, '');
   root.dataset.riCuSources = '';
   state.appliedKey = key;
   return;
  }
  const response = await fetch(g({action:'cart',product_ids:allIds.slice(0,20).join(',')}), {credentials:'same-origin',signal:controller.signal});
  if (!response.ok) throw new Error('recommendations unavailable');
  const result = await response.json();
  if (generation !== state.generation || !root.isConnected) return;
  if (!result.ok) throw new Error('recommendations unavailable');
  const minimum = Math.max(1,Math.min(20,Number(root.dataset.minProducts || 1)));
  const maximum = Math.max(minimum,Math.min(40,Number(root.dataset.maxProducts || 40)));
  const excluded = new Set(allIds), seen = new Set();
  const products = (result.complete || []).filter(item => {
   const id = f(item);
   if (!id || excluded.has(id) || seen.has(id)) return false;
   seen.add(id);
   return true;
  }).slice(0,maximum);
  root.dataset.riCuSources = key;
  state.appliedKey = key;
  iuCartRecommendationRender(root, products.length >= minimum ? E(root.dataset.title || 'Completează-ți ținuta',products) : '');
  if (products.length < minimum) return;
  A(root);
  if (root.dataset.iuEditorialReady) { try { window.sharedFunctions?.setLocalStorageProductForWishlist?.();document.dispatchEvent(new CustomEvent('wishlist:refresh',{bubbles:true})); } catch {} }
  window.IUPagesEditorial?.mountCart(root);
  import(root.dataset.mediaUrl).then(media => { if (generation !== state.generation || !root.isConnected) return;const section=root.querySelector('.ri-cu-section');if(section)media.mount(section);state.disposePhotos=media.mountCartPhotos?.(root); }).catch(() => root.querySelectorAll('img[data-ri-src]').forEach(img => { img.src=img.dataset.riSrc+(img.dataset.riSrc.includes('?')?'&':'?')+'width=640'; }));
 } catch (error) {
  if (generation === state.generation && error.name !== 'AbortError') {
   // Hide outdated suggestions; keep confirmed add feedback and never retry a POST.
   state.appliedKey = null;
   iuCartRecommendationRender(root, '');
  }
 } finally {
  if (generation === state.generation) {
   delete root.dataset.riCuLoading;
   root.removeAttribute('aria-busy');
  }
 }
}
document.addEventListener('cart-update',iuCartRecommendationChanged);
document.addEventListener('cart:updated',iuCartRecommendationChanged);
/* 4.4.16: keep the RI carousel mounted; refresh the native cart without navigation. */
function iuCartFeedback(root, text, needsRefresh = false) {
 let notice = root.querySelector('[data-ri-cu-feedback]');
 if (!notice) {
  notice = document.createElement('p');
  notice.setAttribute('data-ri-cu-feedback', '');
  root.appendChild(notice);
 }
 notice.replaceChildren();
 notice.hidden = !text;
 notice.setAttribute('role', needsRefresh ? 'alert' : 'status');
 if (!text) return;
 notice.appendChild(document.createTextNode(text));
 if (needsRefresh) {
  const link = document.createElement('a');
  link.href = l() + 'cart';
  link.textContent = root.dataset.refreshLinkText;
  notice.appendChild(document.createTextNode(' '));
  notice.appendChild(link);
 }
}
async function j(e,t) {
 const card = t.closest('[data-ri-cu-card]');
 if (!card || e.dataset.riCuAdding === '1') return;
 if (t.dataset.chooseOptions === '1') { location.href = p(card.dataset.handle); return; }
 const variant = t.dataset.variantId;
 if (!variant) return;
 const controls = [...e.querySelectorAll('[data-ri-cu-add]')].map(button => [button, button.disabled]);
 const original = { html: t.innerHTML, title: t.title, label: t.getAttribute('aria-label') };
 let submitted = false, confirmed = false, rejected = false;
 e.dataset.riCuAdding = '1';
 controls.forEach(([button]) => { button.disabled = true; });
 t.classList.add('is-loading');
 t.setAttribute('aria-busy', 'true');
 iuCartFeedback(e, '');
 try {
  if (typeof window.sharedFunctions?.updateCart !== 'function') throw Object.assign(new Error('cart not ready'), { userMessage: e.dataset.notReadyText });
  submitted = true;
  const response = await fetch(`${l()}cart/add.js`, {
   method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
   credentials: 'same-origin', body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
  });
  rejected = !response.ok;
  const added = await response.json();
  if (rejected || Number(added.status) >= 400) {
   rejected = true;
   throw Object.assign(new Error('cart add rejected'), { userMessage: added.description || e.dataset.addErrorText });
  }
  if (!Array.isArray(added.items)) throw new Error(e.dataset.uncertainText);
  confirmed = true;
  O(card.dataset.productId, e.dataset.riCuSources || '');
  t.classList.add('is-added');
  t.innerHTML = S + '<span class="ri-cu-label">' + c(e.dataset.addedText) + '</span>';
  t.title = e.dataset.addedText;
  t.setAttribute('aria-label', e.dataset.addedText);
  // add.js returns added lines, not the complete cart. Read the authoritative totals first.
  const cart = await M();
  const refresh = window.sharedFunctions.updateCart(cart);
  if (!refresh || typeof refresh.then !== 'function') throw new Error('cart refresh unavailable');
  await refresh;
  const total = document.querySelector('[data-cart-total-value]');
  if (!total || Number(total.dataset.cartTotalValue) !== Number(cart.total_price)) throw new Error('cart summary stale');
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart }));
  iuCartFeedback(e, e.dataset.addedText);
 } catch (error) {
  if (!confirmed) {
   t.innerHTML = original.html;
   t.title = original.title;
   t.setAttribute('aria-label', original.label || '');
  }
  // A confirmed or uncertain POST must never be retried automatically or presented as an unsubmitted add.
  const uncertain = submitted && !confirmed && !rejected;
  t.disabled = confirmed || uncertain;
  const text = confirmed ? e.dataset.refreshErrorText : uncertain ? e.dataset.uncertainText : error.userMessage || e.dataset.addErrorText;
  iuCartFeedback(e, text, confirmed || uncertain);
  if (confirmed) {
   const cartRoot = document.querySelector('[data-cart]');
   cartRoot?.classList.remove('is-loading');
   cartRoot?.querySelectorAll('.loading-overlay--custom').forEach(node => node.remove());
  }
 } finally {
  t.classList.remove('is-loading');
  t.removeAttribute('aria-busy');
  controls.forEach(([button, disabled]) => { if (button !== t) button.disabled = disabled; });
  delete e.dataset.riCuAdding;
  iuCartRecommendationFlush(e);
 }
}
function v(e){e.dataset.riCuReady||(e.dataset.riCuReady="1",e.addEventListener("click",t=>{const a=t.target.closest?.("[data-ri-cu-add]");!a||a.disabled||(t.preventDefault(),t.stopPropagation(),j(e,a))}),T(e))}function h(){document.querySelectorAll("[data-iu-cart-recommendations]").forEach(e=>{if(e.dataset.riCuObserved)return;if(e.dataset.riCuObserved="1",!("IntersectionObserver"in window)){v(e);return}const t=new IntersectionObserver(a=>{a.some(i=>i.isIntersecting)&&(t.disconnect(),v(e))},{rootMargin:"500px 0px"});t.observe(e)})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",h):h(),document.addEventListener("shopify:section:load",h)})();
